import { FormDataActions, FormDataActionTypes } from './formDataActions';
import { FormState } from '../../models/ApplicationState';

export const defaultFormState: FormState = {
    applicationFormData: {},
    formDataLoading: false,
    formDataLoadingFailure: false,
    formDataLoadingSuccess: false,
    formSaveLoading: false,
    formSaveFailure: false,
    formSaveSuccess: false,
    formEditLoading: false,
    formEditFailure: false,
    formEditSuccess: false,
    formActionMessage: '',
    formSaveResponse: {},
};

export const formDataReducer = (state: FormState = defaultFormState, action: FormDataActions):
    FormState => {
    switch (action.type) {
        case FormDataActionTypes.LOAD_FORM_DATA:
        return {
            ...state,
            formDataLoading: true,
            formDataLoadingFailure: false,
            formDataLoadingSuccess: false,
        };
        case FormDataActionTypes.LOAD_FORM_DATA_SUCCESS:
        return {
            ...state,
            applicationFormData: {
                ...state.applicationFormData,
                [action.data.formAlias]: action.data.formData
            },
            formDataLoading: false,
            formDataLoadingFailure: false,
            formDataLoadingSuccess: true,
        };
        case FormDataActionTypes.LOAD_FORM_DATA_FAILURE:
        return {
            ...state,
            applicationFormData: {},
            formDataLoading: false,
            formDataLoadingFailure: true,
            formDataLoadingSuccess: false,
        };
        case FormDataActionTypes.SAVE_FORM_DATA:
        return {
            ...state,
            formDataLoading: true,
            // formDataLoadingFailure: false,
            // formDataLoadingSuccess: false,
            formSaveLoading: true,
            formSaveFailure: false,
            formSaveSuccess: false,
        };
        case FormDataActionTypes.SAVE_FORM_DATA_SUCCESS:
        return {
            ...state,
            formDataLoading: false,
            // formDataLoadingFailure: false,
            // formDataLoadingSuccess: true,
            formSaveLoading: false,
            formSaveFailure: false,
            formSaveSuccess: true,
        };
        case FormDataActionTypes.SAVE_FORM_DATA_FAILURE:
        return {
            ...state,
            formActionMessage: action.data,
            formDataLoading: false,
            // formDataLoadingFailure: true,
            // formDataLoadingSuccess: false,
            formSaveLoading: false,
            formSaveFailure: true,
            formSaveSuccess: false,
        };
        case FormDataActionTypes.UPDATE_FORM: return {
            ...state,
            formDataLoading: true,
            // formDataLoadingFailure: false,
            // formDataLoadingSuccess: false,
            formEditLoading: true,
            formEditFailure: false,
            formEditSuccess: false,
        };
        case FormDataActionTypes.UPDATE_FORM_SUCCESS: return {
            ...state,
            formDataLoading: false,
            // formDataLoadingFailure: false,
            // formDataLoadingSuccess: true,
            formEditLoading: false,
            formEditFailure: false,
            formEditSuccess: true,
        };
        case FormDataActionTypes.UPDATE_FORM_FAILURE: return {
            ...state,
            formActionMessage: action.data,
            formDataLoading: false,
            // formDataLoadingFailure: true,
            // formDataLoadingSuccess: false,
            formEditLoading: false,
            formEditFailure: true,
            formEditSuccess: false,
        };
        case FormDataActionTypes.SAVE_FORM_DATA_RESPONSE: return {
            ...state,
            formSaveResponse: action.data,
            formEditLoading: false,
            formEditFailure: false,
            formEditSuccess: true,
        };
        case FormDataActionTypes.RESET_FORM_DATA: return defaultFormState;
        default: return state;
    }
}